/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
import { Carousel } from "@mantine/carousel";
import { Grid } from "@mantine/core";
import React from "react";
import Container from "../Layout/Container/Container";
import NewCardPro from "../NewCardPro";
  
  export default function SlideNews({news}) {
  
//   console.log(22222, news)
    return (
      <section>
        <Container size="xl">
          <div>
        <Grid>  
          <Carousel 
                    dragFree
                    controlSize={50}
                    // slideSize="50%"s
                    // w={330}
                    w="100%"
                    slideGap="xs"
                    bg="#F8F8F8"
                    initialSlide={1}
                    mx="auto"   
                  >

              {news
                ? news.map((item) => (
                    <Grid.Col xs={12} sm={6} lg={4} key={item._id}>
                      <NewCardPro item={item} /* {...console.log(33333,item)}  *//>
                    </Grid.Col>
                  ))
                : Array(4)
                    .fill(undefined)
                    .map((item, i) => (
                        <Grid.Col xs={12} sm={6} lg={4} key={i}>
                            <NewCardPro item={item} isLoading />
                        </Grid.Col>
                    ))}

            </Carousel>
            </Grid>
          </div>
        </Container>
      </section>
    );
  }
  
  